<template>
	<div>
		<b-overlay :show="is_load" rounded="sm">
			<div class="panel-tag">
				{{__t("REST_TAG_PUBLISH")}}
			</div>

			<div class="published mt-2">
				<yes_no
					key="PUBLISHED"
					v-model="rest.published"
					title="PUBLISHED"
				/>
			</div>

			<div class="skeep_sync mt-5">
				<yes_no
					key="SKEEP_SYNC"
					v-model="rest.skeep_sync"
					title="SKEEP_SYNC"
				/>
			</div>

			<div class="is_notify_customer mt-5">
				<yes_no
					key="NOTIFY_CUSTOMER"
					v-model="rest.is_notify_customer"
					title="NOTIFY_CUSTOMER"
				/>
			</div>

			<div class="form-group mt-5">
				<label class="form-label" for="cts">
					{{__t("REST_CITY")}}
				</label>

				<div class="" v-if="cities.length > 0">
					<v-select v-model="active_city"
							  class="imc_reasons"
							  label="title"
							  :options="cities"
							  :filterable="false"
					>
						<template slot="no-options">
							{{__t("CHOICE_CITY")}}
						</template>

						<template slot="option" slot-scope="option">
							<div class="d-center">
								<div>
									{{ option.title }}
								</div>
								<div>
									<small>
										{{option.uniq_id}}
									</small>
								</div>
							</div>
						</template>
					</v-select>
				</div>
			</div>

            <div class="form-group mt-5">
                <label class="form-label" for="cts">
                    {{__t("REST_ORG")}}
                </label>

                <div class="" v-if="orgs.length > 0">
                    <v-select v-model="active_org"
                              class="imc_reasons3"
                              label="title"
                              :options="orgs"
                              :filterable="false"
                    >
                        <template slot="no-options">
                            {{__t("CHOICE_CITY")}}
                        </template>

                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{ option.title }}
                                </div>
                                <div>
                                    <small>
                                        {{option.uniq_id}}
                                    </small>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>

		</b-overlay>

	</div>
</template>

<script>
import vSelect from 'vue-select'
import yes_no from "../../../../sys/radio/yes_no.vue";
export default {
	name: "restaurant_settings",
	components : {
		vSelect,
		yes_no
	},
	props : {
		rest : {
			type : Object
		}
	},
	data() {
		return {
			is_load: false,
			cities : [],
			orgs : [],
		}
	},

	beforeDestroy() {
		EventBus.$off('save_rest_called',this.save_rest);
	},

	created() {
		EventBus.$on("save_rest_called",this.save_rest);
		this.load_cities();
		this.load_organizations();
	},

	methods : {
		async save_rest() {
            EventBus.$emit("save_rest_action");

			this.is_load = true;
			await api.put('/internal/v1/catalog/restaurants/'+ parseInt(this.rest.id), this.rest)
                .then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        EventBus.$emit("reload_restaurants");
                        EventBus.$emit("close_rest");
                    }
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {
					err: response.data.message,
					type: "danger",
					title: response.data.status,
					position : "b-toaster-top-left",
				})
			});
		},

		async load_organizations() {
			this.orgs = [];
			await api.post('/internal/v1/catalog/organizations',{}).then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.orgs = data.data;
				}
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {
					err: response.data.message,
					position : "b-toaster-top-left",
					type: "danger",
					title: response.data.status})
			});
		},

		async load_cities() {
			this.is_load = true;
			this.cities = [];

			await api.get('/internal/v1/catalog/cities').then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.cities = data.data;
				}
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {
					err: response.data.message,
					position : "b-toaster-top-left",
					type: "danger",
					title: response.data.status})
			});
		},
	},

	computed : {
        active_org : {
            get :function () {
                let active = null;
                if(this.orgs.length > 0) {
                    if(this.rest.hasOwnProperty("parent_id")) {
                        this.orgs.map(item => {
                            if(parseInt(item.id) === parseInt(this.rest.parent_id)) {
                                active = item;
                            }
                        })
                    }
                }

                return active;
            },

            set: function (val){
                this.rest.provider = 'sub_g';
                if(val != null) {
                    if (this.rest.hasOwnProperty("parent_id")) {
                        if(val.provider == 'smarttouch_org') {
                            this.rest.provider = 'smarttouch_sub';
                            this.rest.smart_url = '';
                            this.rest.smart_username= '';
                            this.rest.smart_password= '';
                        }
                        this.rest.parent_id = val.id;
                    }
                }
                else {
                    this.rest.parent_id = 0;
                }
            },
        },

		active_city : {
			get :function () {
				let active = null;
				if(this.cities.length > 0) {
					if(this.rest.hasOwnProperty("city_id")) {
						this.cities.map(item => {
							if(parseInt(item.id) === parseInt(this.rest.city_id)) {
								active = item;
							}
						})
					}
				}

				return active;
			},

			set: function (val){
				if(val != null) {
					if (this.rest.hasOwnProperty("city_id")) {
						this.rest.city_id = val.id;
					}
				}
				else {
					this.rest.city_id = 0;
				}
			},
		},
	}
}
</script>

<style scoped>

</style>
